import { Pipe, PipeTransform } from "@angular/core";
import { AvatarSize } from "types/interfaces";

@Pipe({
  name: "convertAvatarToBadgeIconSize",
  standalone: true,
})
export class ConvertAvatarToBadgeIconSizePipe implements PipeTransform {
  transform(value: AvatarSize): string {
    switch (value) {
      case "mini-no-border":
      case "x-mini":
      case "mini":
        return "db-icon-xs";
      case "standard":
      case "standard-no-border":
        return "db-icon-s";
      case "x-large-no-border":
        return "db-icon-lg";
      default:
        return "db-icon-s";
    }
  }
}
